<template>
  <div class="consumeInfo">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">记录详情</span>
    </div>
    <div class="content">
      <div class="top">
        <div class="moneyIcon">￥</div>
        <div class="rechargeName">{{ info.consumeTypeName }}</div>
        <div class="consumeFee">-{{ info.consumeFee }}</div>
      </div>
      <div class="bottom">
        <div v-for="(item, index) in list" :key="index" class="item">
          <div class="name">{{ item.name }}：</div>
          <div class="value">{{ item.value || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { consumeInfo } from '@/api/user';

export default {
  name: 'RecordInfo',
  data() {
    return {
      info: {},
      list: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'expensesRecord' });
    },
    getInfo() {
      consumeInfo({ id: this.$route.query.id }).then(res => {
        this.info = res.data;
        let list = [
          { name: '消费项目', value: res.data.mealRuleName },
          { name: '消费设备', value: res.data.equipmentName },
          { name: '消费方式', value: res.data.consumeTypeName },
          { name: '支付方式', value: res.data.payTypeName }

        ];
        if (res.data.payType === 'COUPON_PAY') {
          const data = [
            { name: '卡券名称', value: res.data.couponName },
            { name: '卡券编号', value: res.data.couponSerial },
            { name: '支付时间', value: res.data.createTime },
            { name: '交易单号', value: res.data.consumeSerial }
          ];
          list = [...new Set([...list, ...data])];
        } else {
          const data = [
            { name: '支付时间', value: res.data.createTime },
            { name: '交易单号', value: res.data.consumeSerial }
          ];
          list = [...new Set([...list, ...data])];
        }
        this.list = list;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.consumeInfo {
  .content {
    display: flex;
    flex-direction: column;

    .top {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 100%;
      .change_val(padding-top, 58);
      .change_val(padding-bottom, 28);
      .moneyIcon {
        .change_val(width, 102);
        .change_val(height, 102);
        .change_val(font-size, 48);
        background: #3B86FF;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
      }

      .rechargeName {
        .change_val(margin-top, 28);
        .change_val(font-size, 28);
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }

      .consumeFee {
        .change_val(font-size, 36);
        .change_val(margin-top, 17);
        font-weight: 600;
        color: #000000;
      }
    }

    .bottom {
      background: #FFFFFF;
      border: 1px solid #EFEFF4;
      box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
      opacity: 1;
      border-radius: 6px;
      .change_margin(margin, 0, 28);
      .change_margin(padding, 33, 42);

      .item {
        display: flex;
        .change_val(font-size, 28);
        .change_val(line-height, 60);
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        opacity: 1;
        .name {
          width: 28%;
        }
        .value {
          width: 72%;
        }
      }
    }
  }
}
</style>
